// src/components/stop/StopInformationPanel.jsx
import React from 'react';
import { Box, Button, Typography, Divider, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import RouteMap from './RouteMap';
import LiveBusesList from './LiveBusesList';
import FrequencyInfo from './FrequencyInfo';
import ServiceLines from './ServiceLines';

function StopInformationPanel({ stop, onClose, userLocation }) {
  if (!stop) return null;

  const stopLat = parseFloat(stop.stop_lat);
  const stopLon = parseFloat(stop.stop_lon);

  // Example data, replace with real props/data fetching
  const liveBuses = [
    { id: 'MB1234', eta: '5 min' },
    { id: 'MB4567', eta: '12 min' },
  ];

  const frequency = 'Every 10 mins from 6:00 AM to 11:00 PM';
  const serviceLines = ['BUS 101', 'BUS 204'];

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: { xs: '100%', sm: 480 },
        height: '100%',
        bgcolor: 'background.paper',
        overflowY: 'auto',
        p: { xs: 2, sm: 4 },
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1500,
      }}
    >
      <Box display="flex" alignItems="center" mb={3}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={onClose}
          sx={{ textTransform: 'none' }}
        >
          Back
        </Button>
        <Typography variant="h5" fontWeight="bold" ml={2} flexGrow={1} noWrap>
          {stop.stop_name}
        </Typography>
      </Box>

      <Divider sx={{ mb: 3 }} />

      <RouteMap stopLat={stopLat} stopLon={stopLon} userLocation={userLocation} />

      <Box my={3}>
        <LiveBusesList buses={liveBuses} />
      </Box>

      <Box my={3}>
        <FrequencyInfo frequency={frequency} />
      </Box>

      <ServiceLines lines={serviceLines} />
    </Paper>
  );
}

export default StopInformationPanel;
